import { FC } from "react";

import ProductContainer from "@app/containers/product";

const AddProductPage: FC = () => <ProductContainer />;

export default AddProductPage;
